module.exports = __webpack_public_path__ + "img/职工5级@3x.4e723d98.png";